module.exports = __webpack_public_path__ + "static/damiano-baschiera-hFXZ5cNfkOk-unsplash-a0dafed40ea0e1952943796d24a2c84b.png";